import React from 'react';
import { motion } from 'framer-motion';
export function BrandMoment() {
  return <section className="py-20 sm:py-32 md:py-48 px-4 sm:px-6 flex flex-col items-center justify-center relative" data-id="element-35">
      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true,
      margin: '-50px'
    }} transition={{
      duration: 1.0,
      ease: 'easeOut'
    }} className="flex flex-col items-center" data-id="element-36">
        {/* P Monogram inside gold circle */}
        <div className="relative w-28 h-28 sm:w-36 sm:h-36 md:w-48 md:h-48 mb-12 sm:mb-16" data-id="element-37">
          <svg viewBox="0 0 200 200" className="w-full h-full" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-38">
            {/* Outer circle */}
            <circle cx="100" cy="100" r="90" stroke="#CFA060" strokeWidth="2.5" fill="none" data-id="element-39" />
            {/* Geometric P letterform */}
            <text x="100" y="118" textAnchor="middle" fontFamily="'Josefin Sans', sans-serif" fontWeight="300" fontSize="80" fill="#CFA060" letterSpacing="0" data-id="element-40">
              P
            </text>
          </svg>
        </div>

        <p className="font-heading text-[10px] sm:text-xs tracking-widest text-brand-warmGrey/60 uppercase" data-id="element-41">
          © 2026 Pollock Ventures
        </p>
      </motion.div>
    </section>;
}